import { render, staticRenderFns } from "./space.vue?vue&type=template&id=df7ade8c&scoped=true&"
import script from "./space.vue?vue&type=script&lang=js&"
export * from "./space.vue?vue&type=script&lang=js&"
import style0 from "./space.vue?vue&type=style&index=0&id=df7ade8c&lang=scss&scoped=true&"
import style1 from "./space.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7ade8c",
  null
  
)

export default component.exports